import script from "./VaultPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VaultPage.vue?vue&type=script&setup=true&lang=js"

import "./VaultPage.vue?vue&type=style&index=0&id=649a1749&lang=scss"

const __exports__ = script;

export default __exports__